export default __webpack_public_path__ + "static/media/gallery_05.0a8a70fb.jpg";